{
  "clientID": "company 1",
  "studies": [
    {
      "block": [
        {
          "config": {
            "id": "1",
            "randomBlock": true,
            "type": "brand",
            "brandName": "Seat",
            "brandImage": "logo_seat.png",
            "practiceBrandImage": "brand_practice.jpeg",
            "practiceBrandName": "Cat",
            "description": "Seat brand",
            "displayName": {
              "EN": "NeedSphere Brand - 5 min",
              "DE": "NeedSphere Marke - 5 min"
            },
            "proceedAutomatically": false
          }
        },
        {
          "config": {
            "id": "2",
            "randomBlock": true,
            "type": "brand",
            "brandName": "Volvo",
            "brandImage": "logo_volvo.png",
            "practiceBrandImage": "brand_practice.jpeg",
            "practiceBrandName": "Cat",
            "description": "Volvo brand",
            "displayName": {
              "EN": "NeedSphere Brand - 5 min",
              "DE": "NeedSphere Marke - 5 min"
            },
            "proceedAutomatically": false
          }
        },
        {
          "config": {
            "id": "3",
            "randomBlock": true,
            "type": "brand",
            "brandName": "Dacia",
            "brandImage": "logo_dacia.png",
            "practiceBrandImage": "brand_practice.jpeg",
            "practiceBrandName": "Cat",
            "description": "Dacia brand",
            "displayName": {
              "EN": "NeedSphere Brand - 5 min",
              "DE": "NeedSphere Marke - 5 min",
              "JP": "NeedSphere Brand - 5 min"
            },
            "proceedAutomatically": false
          }
        },
        {
          "config": {
            "id": "4",
            "randomBlock": true,
            "type": "brand",
            "brandName": "Jeep",
            "brandImage": "logo_jeep.png",
            "practiceBrandImage": "brand_practice.jpeg",
            "practiceBrandName": "Cat",
            "description": "Jeep brand",
            "displayName": {
              "EN": "NeedSphere Brand - 5 min",
              "DE": "NeedSphere Marke - 5 min",
              "JP": "NeedSphere Brand - 5 min"
            },
            "proceedAutomatically": false
          }
        },
        {
          "config": {
            "id": "5",
            "randomBlock": true,
            "type": "brand",
            "brandName": "Tesla",
            "brandImage": "logo_tesla.png",
            "practiceBrandImage": "brand_practice.jpeg",
            "practiceBrandName": "Cat",
            "description": "Tesla brand",
            "displayName": {
              "EN": "NeedSphere Brand - 5 min",
              "DE": "NeedSphere Marke - 5 min",
              "JP": "NeedSphere Brand - 5 min"
            },
            "proceedAutomatically": false
          }
        }
      ]
    },
    {
      "block": [
        {
          "config": {
            "id": "1",
            "type": "persona",
            "description": "PersonaNeedsphere",
            "displayName": { "EN": "Needsphere", "DE": "Needsphere" },
            "proceedAutomatically": false
          }
        }
      ]
    }
  ],
  "questions": {
    "config": {
      "questionnaireRepetitions": {
        "q_before": 1,
        "q_final": 1
      }
    },
    "EN": [
      [
        {
          "questionID": "1",
          "question": "What is your gender?",
          "answers": ["Male", "Female", "Non-binary"],
          "type": "radio",
          "required": true,
          "parentQuestions": {},
          "childQuestions": []
        },
        {
          "questionID": "2",
          "question": "Where are you from?",
          "answers": ["Germany", "Japan", "Canada", "USA", "UK"],
          "type": "radio",
          "required": true,
          "parentQuestions": {},
          "childQuestions": [
            {
              "questionID": "3"
            },
            {
              "questionID": "4"
            },
            {
              "questionID": "5"
            },
            {
              "questionID": "6"
            },
            {
              "questionID": "7"
            }
          ]
        },
        {
          "questionID": "3",
          "question": "Which household income do you have per month?",
          "answers": ["<1666€", "<3333€", "<4999€", "<6666€", "<9999€", "<13333€", "<20833€", ">20833€"],
          "type": "radio",
          "required": true,
          "parentQuestions": {
            "questions": [
              {
                "questionID": "2"
              }
            ],
            "conditions": [
              [
                {
                  "questionID": "2",
                  "condition": "Germany"
                }
              ]
            ]
          },
          "childQuestions": []
        },
        {
          "questionID": "4",
          "question": "Which household income do you have per month",
          "answers": ["<333 YEN", "<499 YEN", "<666 YEN", "<833 YEN", "<999 YEN", "<1250 YEN", ">1250 YEN"],
          "type": "radio",
          "required": true,
          "parentQuestions": {
            "questions": [
              {
                "questionID": "2"
              }
            ],
            "conditions": [
              [
                {
                  "questionID": "2",
                  "condition": "Japan"
                }
              ]
            ]
          },
          "childQuestions": []
        },
        {
          "questionID": "5",
          "question": "Which household income do you have per month?",
          "answers": [
            "<833 CAD",
            "<2082 CAD",
            "<3333 CAD",
            "<4583 CAD",
            "<5833 CAD",
            "<7083 CAD",
            "<8333 CAD",
            "<12416 CAD",
            "<16666 CAD",
            ">16666 CAD"
          ],
          "type": "radio",
          "required": true,
          "parentQuestions": {
            "questions": [
              {
                "questionID": "2"
              }
            ],
            "conditions": [
              [
                {
                  "questionID": "2",
                  "condition": "Canada"
                }
              ]
            ]
          },
          "childQuestions": []
        },
        {
          "questionID": "6",
          "question": "Which household income do you have per month?",
          "answers": [
            "<1250 USD",
            "<2083 USD",
            "<2916 USD",
            "<4166 USD",
            "<6249 USD",
            "<8333 USD",
            "<12499 USD",
            "<16666 USD",
            ">16666 USD"
          ],
          "type": "radio",
          "required": true,
          "parentQuestions": {
            "questions": [
              {
                "questionID": "2"
              }
            ],
            "conditions": [
              [
                {
                  "questionID": "2",
                  "condition": "USA"
                }
              ]
            ]
          },
          "childQuestions": []
        },
        {
          "questionID": "7",
          "question": "Which household income do you have per month?",
          "answers": [
            "<833 GBP",
            "<1666 GBP",
            "<2499 GBP",
            "<3333 GBP",
            "<4999 GBP",
            "<6249 GBP",
            "<8333 GBP",
            "<12499 GBP",
            "<16666 GBP",
            ">16666 GBP"
          ],
          "type": "radio",
          "required": true,
          "parentQuestions": {
            "questions": [
              {
                "questionID": "2"
              }
            ],
            "conditions": [
              [
                {
                  "questionID": "2",
                  "condition": "UK"
                }
              ]
            ]
          },
          "childQuestions": []
        },
        {
          "questionID": "8",
          "question": "How old are you?",
          "answers": ["Between 18 and 28", "Between 28 and 35", "Between 35 and 48", "Between 48 and 65", ">65"],
          "type": "radio",
          "required": true,
          "parentQuestions": {},
          "childQuestions": []
        }
      ]
    ],
    "DE": [
      [
        {
          "questionID": "1",
          "question": "Welches Geschlecht hast du?",
          "answers": ["Männlich", "Weiblich", "Divers"],
          "type": "radio",
          "required": true,
          "parentQuestions": {},
          "childQuestions": []
        },
        {
          "questionID": "2",
          "question": "Woher kommst du?",
          "answers": ["Deutschland", "Japan", "Kanada", "USA", "Vereinigtes Königreich"],
          "type": "radio",
          "required": true,
          "parentQuestions": {},
          "childQuestions": [
            {
              "questionID": "3"
            },
            {
              "questionID": "4"
            },
            {
              "questionID": "5"
            },
            {
              "questionID": "6"
            },
            {
              "questionID": "7"
            }
          ]
        },
        {
          "questionID": "3",
          "question": "Welches Haushaltseinkommen hast du pro Monat?",
          "answers": ["<1666€", "<3333€", "<4999€", "<6666€", "<9999€", "<13333€", "<20833€", ">20833€"],
          "type": "radio",
          "required": true,
          "parentQuestions": {
            "questions": [
              {
                "questionID": "2"
              }
            ],
            "conditions": [
              [
                {
                  "questionID": "2",
                  "condition": "Deutschland"
                }
              ]
            ]
          },
          "childQuestions": []
        },
        {
          "questionID": "4",
          "question": "Welches Haushaltseinkommen hast du pro Monat?",
          "answers": ["<333 YEN", "<499 YEN", "<666 YEN", "<833 YEN", "<999 YEN", "<1250 YEN", ">1250 YEN"],
          "type": "radio",
          "required": false,
          "parentQuestions": {
            "questions": [
              {
                "questionID": "2"
              }
            ],
            "conditions": [
              [
                {
                  "questionID": "2",
                  "condition": "Japan"
                }
              ]
            ]
          },
          "childQuestions": []
        },
        {
          "questionID": "5",
          "question": "Welches Haushaltseinkommen hast du pro Monat?",
          "answers": [
            "<833 CAD",
            "<2082 CAD",
            "<3333 CAD",
            "<4583 CAD",
            "<5833 CAD",
            "<7083 CAD",
            "<8333 CAD",
            "<12416 CAD",
            "<16666 CAD",
            ">16666 CAD"
          ],
          "type": "radio",
          "required": true,
          "parentQuestions": {
            "questions": [
              {
                "questionID": "2"
              }
            ],
            "conditions": [
              [
                {
                  "questionID": "2",
                  "condition": "Kanada"
                }
              ]
            ]
          },
          "childQuestions": []
        },
        {
          "questionID": "6",
          "question": "Welches Haushaltseinkommen hast du pro Monat?",
          "answers": [
            "<1250 USD",
            "<2083 USD",
            "<2916 USD",
            "<4166 USD",
            "<6249 USD",
            "<8333 USD",
            "<12499 USD",
            "<16666 USD",
            ">16666 USD"
          ],
          "type": "radio",
          "required": true,
          "parentQuestions": {
            "questions": [
              {
                "questionID": "2"
              }
            ],
            "conditions": [
              [
                {
                  "questionID": "2",
                  "condition": "USA"
                }
              ]
            ]
          },
          "childQuestions": []
        },
        {
          "questionID": "7",
          "question": "Welches Haushaltseinkommen hast du pro Monat?",
          "answers": [
            "<833 GBP",
            "<1666 GBP",
            "<2499 GBP",
            "<3333 GBP",
            "<4999 GBP",
            "<6249 GBP",
            "<8333 GBP",
            "<12499 GBP",
            "<16666 GBP",
            ">16666 GBP"
          ],
          "type": "radio",
          "required": true,
          "parentQuestions": {
            "questions": [
              {
                "questionID": "2"
              }
            ],
            "conditions": [
              [
                {
                  "questionID": "2",
                  "condition": "Vereinigtes Königreich"
                }
              ]
            ]
          },
          "childQuestions": []
        },
        {
          "questionID": "8",
          "question": "Wie alt bist du?",
          "answers": ["18 bis 28", "28 bis 35", "35 bis 48", "48 bis 65", ">65"],
          "type": "radio",
          "required": true,
          "parentQuestions": {},
          "childQuestions": []
        }
      ]
    ],
    "JP": [
      [
        {
          "questionID": "1",
          "question": "あなたの性別は何ですか？",
          "answers": ["男性", "女性", "ノンバインナリー"],
          "type": "radio",
          "required": true,
          "parentQuestions": {},
          "childQuestions": []
        },
        {
          "questionID": "2",
          "question": "ご出身はどちらですか？",
          "answers": ["ドイツ", "日本", "カナダ", "米国", "イギリスor 英国"],
          "type": "radio",
          "required": true,
          "parentQuestions": {},
          "childQuestions": [
            {
              "questionID": "3"
            },
            {
              "questionID": "4"
            },
            {
              "questionID": "5"
            },
            {
              "questionID": "6"
            },
            {
              "questionID": "7"
            }
          ]
        },
        {
          "questionID": "3",
          "question": "あなたの世帯月収がどの範囲に該当するか、以下の選択肢の中から選んでください",
          "answers": ["<1666€", "<3333€", "<4999€", "<6666€", "<9999€", "<13333€", "<20833€", ">20833€"],
          "type": "radio",
          "required": true,
          "parentQuestions": {
            "questions": [
              {
                "questionID": "2"
              }
            ],
            "conditions": [
              [
                {
                  "questionID": "2",
                  "condition": "ドイツ"
                }
              ]
            ]
          },
          "childQuestions": []
        },
        {
          "questionID": "4",
          "question": "あなたの世帯月収がどの範囲に該当するか、以下の選択肢の中から選んでください",
          "answers": ["<333 YEN", "<499 YEN", "<666 YEN", "<833 YEN", "<999 YEN", "<1250 YEN", ">1250 YEN"],
          "type": "radio",
          "required": true,
          "parentQuestions": {
            "questions": [
              {
                "questionID": "2"
              }
            ],
            "conditions": [
              [
                {
                  "questionID": "2",
                  "condition": "日本"
                }
              ]
            ]
          },
          "childQuestions": []
        },
        {
          "questionID": "5",
          "question": "あなたの世帯月収がどの範囲に該当するか、以下の選択肢の中から選んでください",
          "answers": [
            "<833 CAD",
            "<2082 CAD",
            "<3333 CAD",
            "<4583 CAD",
            "<5833 CAD",
            "<7083 CAD",
            "<8333 CAD",
            "<12416 CAD",
            "<16666 CAD",
            ">16666 CAD"
          ],
          "type": "radio",
          "required": true,
          "parentQuestions": {
            "questions": [
              {
                "questionID": "2"
              }
            ],
            "conditions": [
              [
                {
                  "questionID": "2",
                  "condition": "カナダ"
                }
              ]
            ]
          },
          "childQuestions": []
        },
        {
          "questionID": "6",
          "question": "あなたの世帯月収がどの範囲に該当するか、以下の選択肢の中から選んでください",
          "answers": [
            "<1250 USD",
            "<2083 USD",
            "<2916 USD",
            "<4166 USD",
            "<6249 USD",
            "<8333 USD",
            "<12499 USD",
            "<16666 USD",
            ">16666 USD"
          ],
          "type": "radio",
          "required": true,
          "parentQuestions": {
            "questions": [
              {
                "questionID": "2"
              }
            ],
            "conditions": [
              [
                {
                  "questionID": "2",
                  "condition": "米国"
                }
              ]
            ]
          },
          "childQuestions": []
        },
        {
          "questionID": "7",
          "question": "あなたの世帯月収がどの範囲に該当するか、以下の選択肢の中から選んでください",
          "answers": [
            "<833 GBP",
            "<1666 GBP",
            "<2499 GBP",
            "<3333 GBP",
            "<4999 GBP",
            "<6249 GBP",
            "<8333 GBP",
            "<12499 GBP",
            "<16666 GBP",
            ">16666 GBP"
          ],
          "type": "radio",
          "required": true,
          "parentQuestions": {
            "questions": [
              {
                "questionID": "2"
              }
            ],
            "conditions": [
              [
                {
                  "questionID": "2",
                  "condition": "イギリスor 英国"
                }
              ]
            ]
          },
          "childQuestions": []
        },
        {
          "questionID": "8",
          "question": "あなたは何歳ですか？",
          "answers": [
            "満18歳以上満28歳未満",
            "満28歳以上満35歳未満",
            "満35歳以上満48歳未満",
            "満48歳以上満65歳未満",
            ">65"
          ],
          "type": "radio",
          "required": true,
          "parentQuestions": {},
          "childQuestions": []
        }
      ]
    ],
    "FR": [
      [
        {
          "questionID": "1",
          "question": "Quel est votre genre?",
          "answers": ["Homme", "Femme", "Non-binaire"],
          "type": "radio",
          "required": true,
          "parentQuestions": {},
          "childQuestions": []
        },
        {
          "questionID": "2",
          "question": "D'où venez-vous?",
          "answers": ["Allemagne", "Japon", "Canada", "USA", "Royaume-Uni"],
          "type": "radio",
          "required": true,
          "parentQuestions": {},
          "childQuestions": [
            {
              "questionID": "3"
            },
            {
              "questionID": "4"
            },
            {
              "questionID": "5"
            },
            {
              "questionID": "6"
            },
            {
              "questionID": "7"
            }
          ]
        },
        {
          "questionID": "3",
          "question": "Quel est le revenu de votre ménage par mois?",
          "answers": ["<1666€", "<3333€", "<4999€", "<6666€", "<9999€", "<13333€", "<20833€", ">20833€"],
          "type": "radio",
          "required": true,
          "parentQuestions": {
            "questions": [
              {
                "questionID": "2"
              }
            ],
            "conditions": [
              [
                {
                  "questionID": "2",
                  "condition": "Allemagne"
                }
              ]
            ]
          },
          "childQuestions": []
        },
        {
          "questionID": "4",
          "question": "Quel est le revenu de votre ménage par mois?",
          "answers": ["<333 YEN", "<499 YEN", "<666 YEN", "<833 YEN", "<999 YEN", "<1250 YEN", ">1250 YEN"],
          "type": "radio",
          "required": true,
          "parentQuestions": {
            "questions": [
              {
                "questionID": "2"
              }
            ],
            "conditions": [
              [
                {
                  "questionID": "2",
                  "condition": "Japon"
                }
              ]
            ]
          },
          "childQuestions": []
        },
        {
          "questionID": "5",
          "question": "Quel est le revenu de votre ménage par mois?",
          "answers": [
            "<833 CAD",
            "<2082 CAD",
            "<3333 CAD",
            "<4583 CAD",
            "<5833 CAD",
            "<7083 CAD",
            "<8333 CAD",
            "<12416 CAD",
            "<16666 CAD",
            ">16666 CAD"
          ],
          "type": "radio",
          "required": true,
          "parentQuestions": {
            "questions": [
              {
                "questionID": "2"
              }
            ],
            "conditions": [
              [
                {
                  "questionID": "2",
                  "condition": "Canada"
                }
              ]
            ]
          },
          "childQuestions": []
        },
        {
          "questionID": "6",
          "question": "Quel est le revenu de votre ménage par mois?",
          "answers": [
            "<1250 USD",
            "<2083 USD",
            "<2916 USD",
            "<4166 USD",
            "<6249 USD",
            "<8333 USD",
            "<12499 USD",
            "<16666 USD",
            ">16666 USD"
          ],
          "type": "radio",
          "required": true,
          "parentQuestions": {
            "questions": [
              {
                "questionID": "2"
              }
            ],
            "conditions": [
              [
                {
                  "questionID": "2",
                  "condition": "USA"
                }
              ]
            ]
          },
          "childQuestions": []
        },
        {
          "questionID": "7",
          "question": "Quel est le revenu de votre ménage par mois?",
          "answers": [
            "<833 GBP",
            "<1666 GBP",
            "<2499 GBP",
            "<3333 GBP",
            "<4999 GBP",
            "<6249 GBP",
            "<8333 GBP",
            "<12499 GBP",
            "<16666 GBP",
            ">16666 GBP"
          ],
          "type": "radio",
          "required": true,
          "parentQuestions": {
            "questions": [
              {
                "questionID": "2"
              }
            ],
            "conditions": [
              [
                {
                  "questionID": "2",
                  "condition": "Royaume-Uni"
                }
              ]
            ]
          },
          "childQuestions": []
        },
        {
          "questionID": "8",
          "question": "Quel âge avez-vous?",
          "answers": ["Entre 18 et 28", "Entre 28 et 35", "Entre 35 et 48", "Entre 48 et 65", ">65"],
          "type": "radio",
          "required": true,
          "parentQuestions": {},
          "childQuestions": []
        }
      ]
    ]
  },
  "screening": {
    "config": {},
    "EN": [
      [
        {
          "questionID": "1",
          "question": "Which language do you speak ?",
          "answers": ["German", "English", "Frnech", "German and English"],
          "type": "radio",
          "required": true,
          "rule": { "type": "equal", "value": "German and English" }
        },
        {
          "questionID": "2",
          "question": "Have you recently purchased a device from XY firm ?",
          "answers": ["yes", "no"],
          "type": "radio",
          "required": true,
          "rule": {
            "type": "equal",
            "value": "yes"
          }
        },
        {
          "questionID": "3",
          "question": "How much did it cost ?",
          "answers": [50, 100, 200, 300],
          "type": "radio",
          "required": true,
          "rule": {
            "type": "greaterThan",
            "value": 100
          }
        }
      ]
    ]
  }
}
